module.exports = __webpack_public_path__ + "static/media/26UNRWA9.d02ce48c.jpg";